import { isMockMode, post, simulateDelay } from "../api";

export const deleteOffering = (data) => {
	// define defaults
	data.note = data.note || "";

	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Offerings/Delete`, data, {
		successMessage: "Offering successfully deleted",
	});
};
